import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { fetchDrmTableData } from "../../service/fetchDrmTableData";
import {
  setCeaProfileListSuccess,
  setCeaProfileListFailure,
} from "../reducers/drmCeaProfileListSlice";
import { ENUM_DATA } from "../../constData/enum";

export function* workerGetCeaProfileList({ payload }) {
  const controller = new AbortController();
  try {
    const response = yield call(fetchDrmTableData, [
      payload.pageNum,
      payload.reqBody,
      payload.pageSize,
      payload.tableName,
      controller,
    ]);

    const data = response.data;
    const formattedData = data?.details?.data || [];

    yield put(
      setCeaProfileListSuccess({
        ceaProfileList: formattedData,
        onPage: data?.details?.onPage ?? 0,
        pageSize: data?.details?.pageSize ?? 0,
        totalPages: data?.details?.totalPages ?? 0,
        totalRecords: data?.details?.totalRecords ?? 0,
      })
    );
  } catch (error) {
    yield put(setCeaProfileListFailure(error.toString() || ENUM_DATA.Blank));
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

function* drmCeaProfileListSaga() {
  yield takeLatest("drmCeaProfileList/getCeaProfileList", workerGetCeaProfileList);
}

export default drmCeaProfileListSaga;
